import { Card, Divider, Skeleton } from '@packages/webshop-design-system';

const SignupFormSkeleton = () => {
  return (
    <Card className="rounded-xl">
      <div>
        {/* Heading */}
        <Skeleton className="h-6 w-56" />

        {/* Description text */}
        <Skeleton className="mt-3 h-4 w-full" />

        <Divider className="my-4" />
      </div>

      <div className="flex flex-col gap-3">
        {/* Email field */}
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-12 w-full rounded-md" />
        </div>

        {/* First name field */}
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-12 w-full rounded-md" />
        </div>

        {/* Last name field */}
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-12 w-full rounded-md" />
        </div>

        {/* Phone number field */}
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-12 w-full rounded-md" />
        </div>

        <Divider />

        {/* Password section heading */}
        <Skeleton className="h-4 w-36" />

        {/* Password complexity description */}
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-2/3" />

        {/* Password field */}
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-12 w-full rounded-md" />
        </div>

        {/* Repeat password field */}
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 w-36" />
          <Skeleton className="h-12 w-full rounded-md" />
        </div>

        <Divider />

        {/* Consents */}
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>

        {/* Submit button */}
        <Skeleton className="mt-3 h-12 w-full rounded-md" />
      </div>
    </Card>
  );
};

export default SignupFormSkeleton;
